import { AnalyticsEvents } from '../../analytics/analytics.types.js';
import { useAnalytics } from '../../analytics/hooks/useAnalytics.js';
import { useContextAccessToken } from '../../permission/contexts/AnonShareTokenContext.js';
import { useQueryCacheResourceHelpers } from '../../resources/utils/useQueryCacheResourceHelpers.js';
import { toast } from '../../store/alerts.js';
import { useWoody } from '../../woody/woody.js';
import { useMutation } from '@tanstack/react-query';
import { captureException } from '@fabric-app/compat/capabilities/sentry';
import { ensureError } from '@fabric-app/utils/guards';

const useMutationResourceDescriptionUpdate = (resourceId) => {
  const { client } = useWoody();
  const { updateCachedResource } = useQueryCacheResourceHelpers();
  const { track } = useAnalytics();
  const accessToken = useContextAccessToken();
  const mutation = useMutation({
    mutationKey: [
      "resource-rename",
      resourceId
    ],
    mutationFn: async ({ resource, newDescription }) => {
      if (resource.description === newDescription) {
        return Promise.resolve();
      }
      return client.v2({
        endpoint: "/v2/resources/{resourceId}",
        params: {
          resourceId: resource.id
        }
      }, {
        method: "patch",
        body: {
          description: newDescription
        },
        query: {
          accessToken
        }
      });
    },
    onMutate: ({ resource, newDescription }) => {
      return updateCachedResource({
        id: resource.id,
        description: newDescription
      });
    },
    onError: (error, _v, context) => {
      toast({
        id: "failed-to-update-description",
        replace: true,
        content: "Failed to update description"
      });
      captureException(ensureError(error));
      context?.resetCacheToPreOptimisticState();
      context?.invalidateQueries();
    },
    onSuccess: (_, { resource }) => {
      track(AnalyticsEvents.RenamedResource, {
        resourceId: resource.id,
        type: resource.kind
      });
    }
  });
  return mutation;
};

export { useMutationResourceDescriptionUpdate };
//# sourceMappingURL=useMutationResourceDescriptionUpdate.js.map
